// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"d96dc2960c94a48599ac","731":"4c1b2ac8ee8a1a833a8b","843":"ebd8d017f8a62527e3b6","883":"6aecf95863252e509130"}[chunkId] + ".js";
};